export enum OfferType {
  REJECTION = 'REJECTION',
  OFFER = 'OFFER',
  EXTERNAL_COVERAGE = 'EXTERNAL_COVERAGE',
  FIXED = 'FIXED',

}
